<div>
  <!-- Subscriber Savings Agreement Modal (SSA) -->
  <div bsModal
    #subscriberSavingsAgreementModal="bs-modal"
    id="subscriberSavingsAgreementModal"
    class="modal fade"
    role="dialog"
    [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg-custom">
      <div class="modal-content p-4">
        <div class="modal-title text-center">
          <h5 class="primary-textcolor text-center mbt-1 font-weight-bold">
            Subscriber's Agreement Terms and Conditions
          </h5>
        </div>
        <div class="modal-body">
          <p class="text-center">
            <span class="primary-textcolor font-weight-bold">Policy Number(s):</span>
            <Strong> {{ subscriberSavingsAgreementPolicyList.join(", ") }}</Strong>
          </p>
          <p class="sub-content">
            Thank you for choosing Tower Hill Insurance Exchange! Please carefully review the terms and
            provisions of the <a target="_blank" href="{{subscriberSavingsAgreementUrl}}">
            <span class="font-weight-bold primary-textcolor">Tower Hill Insurance Exchange
            Subscriber's Agreement and Power of Attorney.</span></a>
            By clicking accept, you are confirming that you are authorized
            to accept the terms of the agreement to become a subscriber of Tower Hill Insurance Exchange,
            and you hereby agree to and electronically sign and accept the terms and provisions in the
            Subscriber's Agreement and Power of Attorney. Your response also confirms the appointment of
            Tower Hill Risk Management, as the required attorney-in-fact for Tower Hill Insurance Exchange
            (also referred to as “Tower Hill Exchange”).
          </p>
          <div class="row col-12 subscriber-buttons">
            <button class="btn btn-primary col mb-0 mb-lg-4"
              name="subscriberSavingsAgreementAcceptButton"
              id="subscriberSavingsAgreementAcceptButton"
              (click)="subscriberSavingsAgreementModalSubmit()">Accept
            </button>
            <button class="btn btn-primary col mb-0 mb-lg-4 ml-3"
              name="showMeLaterButton"
              id="showMeLaterButton"
              (click)="subscriberSavingsAgreementModalShowMeLater()">Show Me Later
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Subscriber Savings Agreement Modal (SSA) -->
</div>
